import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService{

  public swalWithBootstrapButtons: typeof Swal;

  constructor() { }

  
  showErrorMessage(title, message) {
    const swalButtons = Swal.mixin({
      customClass: {
        confirmButton: 'mat-raised-button confirm-swal-button'
      },
      buttonsStyling: false
    });

    swalButtons.fire({
      title: title,
      text: message,
      icon: 'error',
      allowOutsideClick: false
    });
  }

  showSuccessMessage(title, message) : Promise<any> {
    const swalButtons = Swal.mixin({
      customClass: {
        confirmButton: 'confirm-swal-button'
      },
      buttonsStyling: false
    });

    return swalButtons.fire({
      title: `<img src="./../../../../app/../assets/images/check.png"/>`,
      text: `${title} 
      ${message}`,
      // icon: 'success',
      allowOutsideClick: false
    });
  }

  showWarnMessage(title, message)  {
    const swalButtons = Swal.mixin({
      customClass: {
        confirmButton: 'mat-raised-button confirm-swal-button'
      },
      buttonsStyling: false
    });

    swalButtons.fire({
      title: title,
      text: message,
      icon: 'warning',
      allowOutsideClick: false
    });
  }

  showConfirmMessage(data:any) : Promise<any> {
    const showCancel = data.cancelBtn? true : false;
    const swalButtons = Swal.mixin({
      customClass: {
        title: 'title-swal',
        confirmButton: 'mat-raised-button confirm-swal-button',
        cancelButton: 'mat-raised-button cancel-swal-button',
        closeButton: 'mat-close-button close-swal-button',
        popup: data.popupClass,
        content: data.contentClass,
        header: data.headerClass
      },
      buttonsStyling: false
    });

   return swalButtons.fire({
      title: data.title,
      text: data.message,
      icon: data.icon,
      showCancelButton: showCancel,
      confirmButtonText: data.confirmBtn,
      cancelButtonText: data.cancelBtn,
      focusConfirm: false,
      allowOutsideClick: false,
      reverseButtons: true,
     showCloseButton: true
    });
  }

  showMessageOnDelete(title,message):Promise<any>{
    const swalButtons = Swal.mixin({
      customClass:{
        confirmButton:"confirm-swal-button",
        title:"success-title",
      },
      buttonsStyling:false,
    });

    return swalButtons.fire({
      title:"Success",
      text:message,
      allowOutsideClick: false,
    })
  }
}

